<template>
    <div>

        <div class="newNav" >
            <div style="height: 56px;">
                <img style="width: 100%;height: inherit;position: absolute;" src="../../../../static/img/yushelan.png" alt="">
            </div>
            <el-menu default-active="1-4-1" class="el-menu-vertical-demo"
                     :collapse="true">
                <el-submenu index="1"  :disabled="true">
                    <template slot="title">

                        <div class="content-title">
                            无人机:{{wuName}}
                        </div>
                    </template>
                </el-submenu>
                <el-submenu index="2"  :disabled="true">
                    <template slot="title">
                        <div class="content-title">
                            传感器:{{chuangName}}
                        </div>
                    </template>
                </el-submenu>
                <el-submenu index="3"  :disabled="true">
                    <template slot="title">
                        <div class="content-title">
                            起飞地点:{{qiName}}
                        </div>
                    </template>

                </el-submenu>
                <el-submenu index="4"  :disabled="true" >
                    <template slot="title">
                        <div class="content-title">
                            地面控制点:{{dirName}}
                        </div>
                    </template>
                </el-submenu>
                <div class="addElement"  :class="{active:tiBoolean }"  @click="submitForm(1)">
                    飞行结果查询与导出
                </div>
                <div class="addElement" :class="{active:tiBoolean }"  @click="submitForm(2)">
                    三维建模
                </div>
            </el-menu>

        </div>
    </div>

</template>

<script>
    export default {
        props:["ifShowIframe", "activeIndex"],
        name: "index",
        data() {
            return {
                tiBoolean:false,
                wuName: '',
                chuangName: '',
                qiName: '',
                dirName: '',
            }
        },
        methods: {
            submitForm(index) {
                if (index === 1 &&   this.tiBoolean) {
                    this.goMain('/flight')
                } else if(index === 2 &&   this.tiBoolean) {
                    this.goMain('/modeling')

                }else{
                    this.$message.error('请先设置航线规划参数');
                }
            },
            getData() {
                this.wuName = this.$route.query.wurenjiName
                this.chuangName = this.$route.query.chuangName
                this.dirName = this.$route.query.dirName
                this.qiName = this.$route.query.qifei
            }
        },
        created() {
                this.getData()
        },
        watch:{
            ifShowIframe(){
                console.log('2222');
                this.tiBoolean = true
            }
        }

    }
</script>

<style lang="less" scoped>
    .active{
        color: white !important;
        cursor: pointer !important;

    }
    .el-menu--popup {
        margin-right: 0 !important;
        padding: 0 !important;
    }

    /deep/ .el-menu-item-group__title {
        padding: 0 !important;
    }

    /deep/ .el-menu-item:hover {
        background: #66a3ba !important;
    }

    /deep/ .el-menu--popup-right-start {
        margin-right: 0 !important;
        margin-left: 0 !important;
    }

    /deep/ .el-menu-item {
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        color: white;
        background: #1e354c;
    }

    .newNav {
        width: 190.36px;
        position: absolute;
        z-index: 999;
        left: 20px;
        top: 40vh;
        width: 13.5%;
        //nav 盒子大小
        .el-menu--collapse {
            width: 100%;
        }
        //
        .el-submenu:first-child {
            border: 2px solid #66a3ba;
            border-image: -webkit-linear-gradient(#66a3ba, #83ccde) 30 30;
            border-image: -moz-linear-gradient(#66a3ba, #83ccde) 30 30;
        }
        .el-submenu {
            border-bottom: 2px solid #66a3ba;
            border-left: 2px solid #66a3ba;
            border-right: 2px solid #66a3ba;

        }

        .el-submenu__title {
            padding: 0 !important;

        }
        /deep/ .el-submenu__title:hover {
            background: #1e354c;
        }
        .el-menu--collapse .el-submenu {
            color: white !important;
            background: #1e354c;
        }

        /deep/ .el-menu-item-group__title {
            padding: 0 !important;
        }

        .content-title {
            color: white;
            text-align: center;
            font-size: 14px;
            font-weight: 600;
        }
        .addElement {
            height: 56px;
            border-bottom: 2px solid #66a3ba;
            border-left: 2px solid #66a3ba;
            border-right: 2px solid #66a3ba;
            text-align: center;
            line-height: 56px;
            background: #1e354c;
            cursor: not-allowed;
            color: #b7b7b77d;
            font-weight: 700;
            font-size: 14px;
        }

        //子级导航背景色

    }

</style>


// WEBPACK FOOTER //
// src/components/Altizure/newNav/index.vue